import { useTheme } from '../../lib/theme.jsx'
import { MonitorIcon, MoonIcon, SunIcon } from './ThemeIcons.jsx'
import './theme.css'

// The theme control: three positions, in the top bar, next to Sign out.
//
// Icons rather than a menu, for two reasons. A menu costs a click to see the
// state it is in, and this control's whole job is to be legible at a glance in
// a 56px bar that already carries a wordmark, a name and a shop. And a shop
// with a counter touchscreen gets three 36px targets instead of one 36px target
// that opens a list of three more.
//
// System is listed last and is the default. Light and Dark are the exceptions a
// person chooses; System is the state they were already in.

const OPTIONS = [
  { value: 'light', label: 'Light', title: 'Light theme', Icon: SunIcon },
  { value: 'dark', label: 'Dark', title: 'Dark theme', Icon: MoonIcon },
  { value: 'system', label: 'System', title: 'Match this device', Icon: MonitorIcon },
]

const RESOLVED_WORD = { light: 'light', dark: 'dark' }

export default function ThemeToggle() {
  const { theme, resolved, setTheme } = useTheme()

  // Said out loud when it changes. aria-pressed alone tells a screen-reader
  // user which button they just pressed, not what the page now looks like —
  // and for System those are different facts.
  const announcement =
    theme === 'system'
      ? `Theme: matching this device, currently ${RESOLVED_WORD[resolved]}.`
      : `Theme: ${RESOLVED_WORD[resolved]}.`

  return (
    <div className="theme-toggle" role="group" aria-label="Colour theme">
      {OPTIONS.map(({ value, label, title, Icon }) => {
        const chosen = theme === value
        return (
          <button
            key={value}
            type="button"
            className={chosen ? 'theme-toggle-btn is-on' : 'theme-toggle-btn'}
            // A real pressed state, not a class the assistive layer cannot see.
            aria-pressed={chosen}
            title={
              value === 'system' ? `${title} (currently ${RESOLVED_WORD[resolved]})` : title
            }
            onClick={() => setTheme(value)}
          >
            <Icon />
            <span className="visually-hidden">{label}</span>
          </button>
        )
      })}
      <span className="visually-hidden" role="status">
        {announcement}
      </span>
    </div>
  )
}
